import React from 'react'
import {AiFillCaretDown, AiFillCaretUp} from 'react-icons/ai';
import styles from '../../styles/product/order_food_message.module.scss'

export default function OrderFoodMessage() {
  const [isMessageVisible, setIsMessageVisible] = React.useState(false)

  const handleButtonClick = React.useCallback(() => {
    setIsMessageVisible(!isMessageVisible);
  }, [isMessageVisible])

  return <>
    <button className={`btn btn-link ${styles.button}`} onClick={handleButtonClick}>
      Ordering Food?
      {isMessageVisible ? (
        <AiFillCaretUp />
      ) : (
        <AiFillCaretDown />
      )}
    </button>
    {isMessageVisible && (
      <div>
        {/* Check out with
        {' '}
        <a href="https://forms.gle/98RQyYq7j9EVcYz58">Eat4ward</a>
        {' '}
        here to prevent order cancellation. */}
        Make sure the food doesn't requires chilling to survive the journey!
      </div>
    )}
  </>
}